module.exports = __webpack_public_path__ + "static/media/ic_paypal.abf9c184.svg";